export default __webpack_public_path__ + "67e9635c904fe2ecd262265ab087766e.svg";